import type {Block, BlockProperties} from 'grapesjs';

/** DOM id on the Elements category tile — the stock-media popup points its arrow at it by default. */
export const ELEMENTS_BLOCK_ANCHOR_ID = 'email-elements-block-anchor';

/** DOM id on the Image category tile — the stock-media popup points its arrow at it when a flow starts from the Image panel. */
export const IMAGE_BLOCK_ANCHOR_ID = 'email-image-block-anchor';

export type BlockCategoryMap = Record<string, Block[]>;

export interface EmailMakerBlockAttributes extends BlockProperties {
  sortPriority?: number;
}
export interface UserHasSeenServerResponse {
  hasSeen: number;
}

export interface CategoryPill {
  id: number;
  name: string;
  trackingName: string;
}

export interface EmailComponentTemplateCategory {
  id: number;
  name: string;
  trackingName: string;
  sortOrder: number;
}

export interface EmailComponentTemplate {
  id: number;
  jsonContent: string;
  categoryId: number;
  hasGif: boolean;
  sortOrder: number;
  desktopPreviewUrl: string;
  mobilePreviewUrl: string;
}

export interface UserEmailComponentTemplate {
  id: number;
  jsonContent: string;
  hasGif: boolean;
  userId: number;
  name: string;
  desktopPreviewUrl: string;
  mobilePreviewUrl: string;
}

export type UserEmailComponentTemplateWithLoadingState = UserEmailComponentTemplate & {
  isPreviewGenerated: boolean;
};

export interface BlockCategoryData {
  icon: string;
  labelKey: string;
  descriptionKey: string;
  introImageFilename: string | null;
  introTextKey: string | null;
}

export type BlockCategoryDataMap = Record<string, BlockCategoryData>;
